import { createSlice } from '@reduxjs/toolkit';
import { API_IDS } from '../../constants';

// Define the initial value for the slice state
const initialState = {
  failureCounts: {}
};

// Slices contain Redux reducer logic for updating state, and
// generate actions that can be dispatched to trigger those updates.
export const apiCallStateSlice = createSlice({
  name: 'apiCallStates',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    incrementFailureCount: (state, action) => {
      console.log('incrementFailureCount', action);
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.failureCounts[action.payload] = (state.failureCounts[action.payload] || 0) + 1;
    },
    resetFailureCount: (state, action) => {
      state.failureCounts[action.payload] = 0;
    },
    resetAllFailureCounts: (state) => {
      state.failureCounts = {};
    }
  },
  selectors: {
    getTimerFailedCount: (state) => state.failureCounts[API_IDS.TIMER_SYNC],
    getSaveCountinueFailedCount: (state) => state.failureCounts[API_IDS.SAVE_AND_CONTINUE]
  }
});

// Export the generated action creators for use in components
export const { incrementFailureCount, resetFailureCount, resetAllFailureCounts } =
  apiCallStateSlice.actions;
export const { getTimerFailedCount, getSaveCountinueFailedCount } = apiCallStateSlice.getSelectors(
  (state) => state.apiCallStates
);

// Export the slice reducer for use in the store configuration
export default apiCallStateSlice.reducer;
